const state = {
    snack_bar: {
        show: false,
        text: '',
        type: 0,
    }
};

const getters = {
    get_snack_bar: state => {
        return state.snack_bar
    },
    get_snack_bar_color: state => {
        switch (state.snack_bar.type) {
            case 0:
                return 'primary'
            case 1:
                return 'success'
            case 2:
                return 'red'
        }
    }

};

const mutations = {
    show_snackbar(state, payload) {
        state.snack_bar.type = payload.type
        console.log(payload.type)
        state.snack_bar.show = true
        state.snack_bar.text = payload.text
    },
    hide_snackbar(state) {
        state.snack_bar.show = false
        state.snack_bar.text = ""
    }

};

export default {
    state,
    getters,
    mutations,
}
